import { Popup, Cell, CellGroup, Stepper, Grid, GridItem } from 'vant'

export default {
  name: 'HtContactRoom',
  components: {
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Stepper.name]: Stepper,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldTabbar: () => import('Components/ldTabbar/ldTabbar'),
    ldButton: () => import('Common/ldButton'),
  },
  props: {
    c: Object
  },
  data() {
    return {
      isShow: false,
      down: {use:false},
      isContactAge: false, 
      list: [
        { value: '1', text: '≤1岁' },
        { value: '2', text: '2岁' },
        { value: '3', text: '3岁' },
        { value: '4', text: '4岁' },
        { value: '5', text: '5岁' },
        { value: '6', text: '6岁' },
        { value: '7', text: '7岁' },
        { value: '8', text: '8岁' },
        { value: '9', text: '9岁' },
        { value: '10', text: '10岁' },
        { value: '11', text: '11岁' },
        { value: '12', text: '12岁' },
        { value: '13', text: '13岁' },
        { value: '14', text: '14岁' },
        { value: '15', text: '15岁' },
        { value: '16', text: '16岁' },
        { value: '17', text: '17岁' }
      ],
      index: 0,
      data: {}
    }
  },
  mounted () {
    this.data = this.c
  },
  methods: {
    getData() {
      /**
       * 处理data中的model对象值
       */
      this.data.model.adultPopulation = this.data.adultPopulation
      this.data.model.childrenNumber = this.data.childrenNumber
      var index = parseInt(this.data.model.childrenNumber)
      this.data.model.ageItems = []
      for (let i = 0; i < index; i++) {
        this.data.model.ageItems.push(this.data.children[i].age)
      }
      this.$emit('selected', this.data)
      this.toggle()
    },
    toggle(obj) {
      this.isShow = !this.isShow
      if(this.isShow){
        if(obj){
          Object.assign(this, obj)
        }
      }
    },
    emitClick(item) {
      this.data.children[this.index].age = item.value
      this.isContactAge = false
    },
    childrenNumberChange() {
      let index = parseInt(this.data.childrenNumber)
      for (let i = 0; i < this.data.children.length; i++) {
        this.data.children[i].show = false
      }
      for (let i = 0; i < index; i++) {
        this.data.children[i].show = true
      }
    },
    getContactAge(index) {
      this.index = index
      this.isContactAge = true
    },
    clearChildren(index) {
      this.data.childrenNumber -= 1
      this.data.children.splice(index, 1)
      this.data.children.push({
        age: '1',
        show: false
      })
    }
  }
}